import React from 'react'
import { formatToLocalTime } from '../service/Weatherservice'

function TimeAndlocation({gaurav:{dt,timezone,name,country}}) {
  return (
    /*by default flex-column is taken*/
    <div className='flex-row justify-center gap-x-1'>
        <div className='flex items-center justify-center my-6'>
            <p className='text-white text-xl font-extralight'>{formatToLocalTime(dt,timezone)}</p>
        </div>
        <div className='flex items-center justify-center my-3'>
            <p className='text-white text-3xl font-medium'>{`${name},${country}`}</p>
        </div>
        
    </div>
  )
}

export default TimeAndlocation